module.exports = __webpack_public_path__ + "img/title.c59cc5fc.png";